import { alpha, Box, Button, ButtonGroup, Slider, styled, } from '@mui/material';
import { isMediumUI } from 'shared/app/lib/choose-ui-type';
export const TemperatureControlButtonGroup = styled(ButtonGroup, {
    shouldForwardProp: (prop) => prop !== 'widget',
})(({ widget, theme, group_color = theme.palette.heat.main }) => ({
    color: group_color,
    borderRadius: 24,
    padding: 0,
    '& .MuiButtonGroup-grouped:not(:last-of-type)': {
        borderColor: group_color,
    },
    '&.MuiButtonGroup-root': {
        '&:hover': {
            background: 'none',
        },
    },
    '& .MuiButton-root': {
        '&:hover': {
            backgroundColor: alpha(group_color, 0.1),
        },
        padding: 4,
    },
    width: widget ? '32%' : '100%',
    position: widget && !isMediumUI() ? 'absolute' : 'static',
    bottom: widget ? '10%' : undefined,
}));
export const TemperatureControlButton = styled(Button)(() => ({
    borderRadius: 24,
    color: 'inherit',
}));
export const SliderTemperatureControl = styled(Slider, {
    shouldForwardProp: (prop) => prop !== 'is_off_mode' && prop !== 'summer_mode',
})(({ theme, is_off_mode, summer_mode, show_fail }) => ({
    color: theme.palette.heat.main,
    '& .MuiSlider-thumb': {
        display: is_off_mode ? 'none' : 'flex',
        color: show_fail ? theme.palette.error.main : 'inherit',
        '&:hover': {
            boxShadow: `0px 0px 0px 8px ${alpha(theme.palette.heat.main, 0.2)}`,
        },
        '&.Mui-focusVisible': {
            boxShadow: `0px 0px 0px 8px ${alpha(theme.palette.heat.main, 0.2)}`,
        },
    },
    '& .MuiSlider-mark': {
        height: 12,
        color: show_fail
            ? theme.palette.error.main
            : summer_mode
                ? theme.palette.action.disabled
                : theme.palette.heat.main,
        '&Label': {
            color: summer_mode
                ? theme.palette.action.disabled
                : theme.palette.heat.main,
        },
        '&.MuiSlider-markActive': {
            backgroundColor: show_fail
                ? theme.palette.error.main
                : summer_mode
                    ? theme.palette.action.disabled
                    : theme.palette.heat.main,
            height: 12,
        },
    },
    '& .MuiSlider-track': {
        display: is_off_mode || summer_mode ? 'none' : 'block',
        color: show_fail ? theme.palette.error.main : 'inherit',
    },
    '& .MuiSlider-rail': {
        color: show_fail ? theme.palette.error.main : 'inherit',
    },
    //Текущая температра
    '& .MuiSlider-mark[data-index="2"]': {
        pointerEvents: 'none',
        width: 10,
        height: 10,
        transform: 'translate(-4.5px, -50%)',
        borderRadius: '50%',
        color: theme.palette.success.main,
        backgroundColor: theme.palette.success.main,
        zIndex: 100,
        '&.MuiSlider-markActive': {
            backgroundColor: theme.palette.success.main,
            zIndex: 100,
        },
    },
    '& .MuiSlider-markLabel[data-index="2"]': {
        color: theme.palette.success.main,
        top: -20,
    },
}));
export const HeatingModesWrapper = styled(Box)(({ theme }) => ({
    '& .swiper': {
        height: '100%',
        width: '100%',
        userSelect: 'none',
        overflow: 'visible',
    },
    '& .swiper-pagination-lock': {
        display: 'block',
    },
    '& .swiper-button-lock': {
        display: 'flex',
    },
    '& .swiper-button-prev, .swiper-button-next': {
        color: theme.palette.heat.main,
        transform: 'translateY(-50%)',
        top: '0',
        width: 'auto',
        height: 'auto',
        position: 'absolute',
        '&::after': {
            fontSize: isMediumUI() ? '2rem' : '1.5rem',
        },
    },
    '& .swiper-button-disabled': {
        pointerEvents: 'all',
    },
    '& .swiper-button-prev': {
        left: 5,
    },
    '& .swiper-button-next': {
        right: 5,
    },
    '& .swiper-pagination-bullet': {
        backgroundColor: theme.palette.heat.main,
    },
    '& .swiper-pagination-bullet-active': {
        backgroundColor: theme.palette.heat.main,
    },
}));
